var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5.192h30v19.615H0V5.192Z",
    style: {
      fill: "#0064ad"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,15h30M12.115,5.192v19.615"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "15 24.808 9.231 24.808 9.231 17.885 0 17.885 0 12.115 9.231 12.115 9.231 5.192 15 5.192 15 12.115 30 12.115 30 17.885 15 17.885 15 24.808",
    style: {
      fill: "#ffd300"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,15h30M12.115,5.192v19.615"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "13.269 24.808 10.962 24.808 10.962 16.154 0 16.154 0 13.846 10.962 13.846 10.962 5.192 13.269 5.192 13.269 13.846 30 13.846 30 16.154 13.269 16.154 13.269 24.808",
    style: {
      fill: "#da0e15"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAx);
export default __webpack_public_path__ + "static/media/AX.82934b1fd042ca3bd82027d0a279a95d.svg";
export { ForwardRef as ReactComponent };